import React, { useEffect, useState } from "react";
import BoxLayout from "../../../../components/Common/BoxLayout/BoxLayout";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import {
  getAllProgramsCountOrganizeWithoutConditionActionHandler,
  getClassAndCollectionByProgramIdActionHandler,
  getRecentlyAddNewSeriesActionHandler,
} from "../../../../store/actions/actionHandlers/organizeActionHandler";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { addSeriesMgmt } from "../../../../utils/mainTabs/organize/addSeriesMgmt";
import { setSeriesShotclassDataAction } from "../../../../store/actions/actionCreators/organizeActionCreator";
import {
  getCertificateByProgramIdActionHandler,
  getCertificateByProgramIdOrganizeActionHandler,
} from "../../../../store/actions/actionHandlers/distributeActionHandler";
import { setCertificateByProgramIdAction } from "../../../../store/actions/actionCreators/distributeActionCreator";

const CreateNewSeries = () => {
  const dispatch = useDispatch();
  const routerParam = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const pageSize = 8;
  const [classTypeData, setClassTypeData] = useState([]);
  const [loader, setLoader] = useState(false);
  const { tiles: seriesMgmtTiles } = addSeriesMgmt;
  const {
    programCount,
    setProgramCount,
    groupTopicTiles,
    setGroupTopicTiles,
    // seriesMgmtTiles,
    createNewSeriesPath,
    tenantName,
  } = useOutletContext();

  const seriesEditPath = addSeriesMgmt.editpath(tenantName, location);
  const seriesCopyPath = addSeriesMgmt.copypath(tenantName, location);
  const [pathType, setPathType] = useState("");
  const [dataForUpdateProgramByID, setDataForUpdateProgramByID] = useState([]);
  const [shotClassCount, setShotClassCount] = useState(null);
  const getClassDataByID = useSelector((state) => state.organizeReducer);
  const { classAndCollectionDataByID } = getClassDataByID;
  const distributeState = useSelector((state) => state.distributeReducer);
  const { certificateByProgramId } = distributeState;
  // console.log(classAndCollectionDataByID);

  const [formData, setFormData] = useState({
    details: {
      name: "",
      TagsList: [],
      description: "",
      ThumbnailImage: null,
      NoDaysToNotifyBeforeDueDate: 1,
      IsSelfPacedProgram: false,
      IsSpreadProgram: false,
      CanDisplayClassPostDuedate: true,
      DueDate: null,
      Certificate: "",
      Title: "",
    },
    topicContent: {
      TopicCourseAssociations: "",
    },
  });
  useEffect(() => {
    dispatch(
      getAllProgramsCountOrganizeWithoutConditionActionHandler(
        "Published",
        "ShotClass",
        "",
        setShotClassCount
      )
    );
  }, [dispatch, setShotClassCount]);
  const organizeState = useSelector((state) => state.organizeReducer);
  const { seriesShotclassData } = organizeState;
  const [callDefaultApi, setCallDefaultApi] = useState(true);
  useEffect(() => {
    dispatch(setSeriesShotclassDataAction([]));
  }, [dispatch]);

  useEffect(() => {
    if (seriesShotclassData?.length === 0 && callDefaultApi) {
      dispatch(
        getRecentlyAddNewSeriesActionHandler(
          "WithoutVTLT",
          "Published",
          "ShotClass",
          "none",
          "none",
          1,
          pageSize,
          callDefaultApi
        )
      );
    }
  }, [dispatch, seriesShotclassData?.length, setCallDefaultApi]);

  useEffect(() => {
    setClassTypeData(seriesShotclassData);
  }, [seriesShotclassData, setClassTypeData]);
  useEffect(() => {
    if (routerParam?.seriesID) {
      setLoader(true);
      dispatch(
        getClassAndCollectionByProgramIdActionHandler(
          routerParam?.seriesID,
          "en-GB"
        )
      ).then((response) => {
        if (response) {
          if (location.pathname.includes(addSeriesMgmt.copypath(tenantName)))
            setPathType("copy");
          else setPathType("edit");
          setDataForUpdateProgramByID(response?.data);
          setFormData((formData) => {
            return {
              details: {
                name: location.pathname.includes(
                  addSeriesMgmt.copypath(tenantName)
                )
                  ? response?.data?.[0]?.Programs?.Name + "_copy"
                  : response?.data?.[0]?.Programs?.Name,
                TagsList:
                  response?.data?.[0]?.Programs?.Tags?.length == "0"
                    ? []
                    : response?.data?.[0]?.Programs?.Tags?.split(",")?.map(
                        (val) => ({
                          TagName: val,
                        })
                      ),
                description: response?.data?.[0]?.Programs?.Description,
                ThumbnailImage: response?.data?.[0]?.Programs?.ImageUrl,
                CanDisplayClassPostDuedate:
                  !response?.data?.[0]?.Programs?.CanDisplayClassPostDuedate,
                NoDaysToNotifyBeforeDueDate:
                  response?.data?.[0]?.Programs?.NoDaysToNotifyBeforeDueDate,
                IsSpreadProgram: response?.data?.[0]?.Programs?.IsSpreadProgram,
                IsSelfPacedProgram:
                  response?.data?.[0]?.Programs?.IsSelfPacedProgram,
                DueDate:
                  response?.data?.[0]?.Programs?.DueDate?.split("T")?.[0],
                Status: response?.data?.[0]?.Programs?.Status,
                IsPublished: response?.data?.[0]?.Programs?.IsPublished,
              },
              topicContent: {
                TopicCourseAssociations: response?.data?.map((item) => {
                  return {
                    Name: item?.ShotClass?.Name,
                    ID: item?.ShotClass.ID,
                  };
                }),
              },
            };
          });
          // setFormData({
          //   ...formData,
          // });
          setLoader(false);
        }
      });
    }
  }, [dispatch, routerParam?.seriesID]);

  useEffect(() => {
    if (
      routerParam?.seriesID &&
      (pathType === "edit" || pathType === "copy") &&
      !formData?.details?.Certificate
    )
      dispatch(
        getCertificateByProgramIdOrganizeActionHandler(routerParam?.seriesID)
      ).then((response) => {
        if (response?.status === 200 && response?.data) {
          setFormData((prevState) => {
            return {
              ...prevState,
              details: {
                ...prevState?.details,
                Certificate: response?.data?.CertificateID,
                Title: response?.data?.Title,
              },
            };
          });
        }
      });
  }, [dispatch, routerParam, pathType]);

  // console.log(formData);

  useEffect(() => {
    if (location.pathname == createNewSeriesPath) {
      let tilesList = seriesMgmtTiles(
        navigate,
        location,
        routerParam,
        tenantName
      );
      setGroupTopicTiles(tilesList);
      navigate(`${location.pathname}/details`);
    } else if (
      location.pathname.includes(createNewSeriesPath) &&
      groupTopicTiles.length === 0
    ) {
      navigate(createNewSeriesPath);
    }
  }, [
    location,
    createNewSeriesPath,
    routerParam,
    dispatch,
    navigate,
    seriesMgmtTiles,
    seriesMgmtTiles?.length,
    setGroupTopicTiles,
    groupTopicTiles.length,
  ]);
  // useEffect(() => {
  //   if (
  //     classAndCollectionDataByID?.[0]?.Programs?.ID &&
  //     location.pathname.includes(seriesEditPath)
  //   ) {
  //     debugger;
  //     if (location.pathname.includes(seriesEditPath)) {
  //       setPathType("edit");
  //     }
  //   }
  // }, [
  //   classAndCollectionDataByID?.[0]?.Programs?.ID,
  //   location.pathname,
  //   // formData,
  //   seriesEditPath,
  //   routerParam?.seriesID,
  // ]);

  useEffect(() => {
    let tiles = addSeriesMgmt.tiles(
      navigate,
      location,
      routerParam,
      tenantName
    );
    const updatedTiles = tiles.map((tile, index) => {
      if (
        index === 0 &&
        (((pathType === "edit" || pathType === "copy") &&
          ((formData?.details?.name &&
            formData?.details?.TagsList &&
            formData?.details?.description &&
            formData?.details?.ThumbnailImage &&
            !formData?.details?.CanDisplayClassPostDuedate) ||
            (formData?.details?.CanDisplayClassPostDuedate &&
              formData?.details?.NoDaysToNotifyBeforeDueDate &&
              formData?.details?.DueDate &&
              formData?.details?.name &&
              formData?.details?.TagsList &&
              formData?.details?.description &&
              formData?.details?.ThumbnailImage))) ||
          (formData?.details?.name &&
            formData?.details?.TagsList &&
            formData?.details?.description &&
            formData?.details?.ThumbnailImage &&
            formData?.details?.CanDisplayClassPostDuedate) ||
          (formData?.details?.NoDaysToNotifyBeforeDueDate &&
            formData?.details?.DueDate &&
            formData?.details?.name &&
            formData?.details?.TagsList &&
            formData?.details?.description &&
            formData?.details?.ThumbnailImage &&
            !formData?.details?.CanDisplayClassPostDuedate))
      )
        return { ...tile, isCompleted: true };
      else if (
        index === 1 &&
        formData?.topicContent?.TopicCourseAssociations?.length > 0
      )
        return { ...tile, isCompleted: true };
      else if (index === 2 && formData?.details?.IsPublished)
        return { ...tile, isCompleted: true };
      else return { ...tile };
    });
    setGroupTopicTiles(updatedTiles);
  }, [
    formData,
    location,
    navigate,
    routerParam,
    tenantName,
    setGroupTopicTiles,
  ]);

  return (
    <BoxLayout margin={[0, 0, 0, 0]}>
      <Outlet
        context={{
          formData,
          setFormData,
          shotClassCount,
          setShotClassCount,
          pathType,
          groupTopicTiles,
          setGroupTopicTiles,
          seriesMgmtTiles,
          createNewSeriesPath,
          classTypeData,
          setClassTypeData,
          dataForUpdateProgramByID,
          tenantName,
          callDefaultApi,
          setCallDefaultApi,
          seriesEditPath,
          seriesCopyPath,
          setLoader,
          loader,
        }}
      />
    </BoxLayout>
  );
};

export default CreateNewSeries;
